import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import AGGridEnumRenderer from "@/components/inputs/AGGridEnumRenderer.vue";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridTranslatorColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridEnumRenderer;
    colDef.cellRendererParams = {
      metaData: this.column.metaData
    };
    return colDef;
  }
}
